import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import LoginPanel from "./LoginPanel"; // ← same folder as Login.js

class Login extends Component {
  render() {
    return (
      <div className="login-container">
        <LoginPanel />
      </div>
    );
  }
}

export default withRouter(Login);
